export async function ensureWafToken() {
  if (typeof window === 'undefined' || !window.AwsWafIntegration) return;
  try {
    await window.AwsWafIntegration.getToken();
  } catch {
    // token acquisition timed out or failed — proceed without blocking the request
  }
}
